{
  "WHATSAPP_TEMPLATES": {
    "MODAL": {
      "TITLE": "Templates do Whatsapp",
      "SUBTITLE": "Selecione o template do whatsapp que você deseja enviar",
      "TEMPLATE_SELECTED_SUBTITLE": "Configurar modelo: {templateName}"
    },
    "PICKER": {
      "SEARCH_PLACEHOLDER": "Pesquisar modelos",
      "NO_TEMPLATES_FOUND": "Não há templates encontrados para",
      "HEADER": "Cabeçalho",
      "BODY": "Corpo",
      "FOOTER": "Rodapé",
      "BUTTONS": "Botões",
      "CATEGORY": "Categoria",
      "MEDIA_CONTENT": "Conteúdo de Mídia",
      "MEDIA_CONTENT_FALLBACK": "conteúdo de mídia",
      "NO_TEMPLATES_AVAILABLE": "Não há modelos disponíveis do WhatsApp. Clique em atualizar para sincronizar os modelos do WhatsApp.",
      "REFRESH_BUTTON": "Atualizar modelos",
      "REFRESH_SUCCESS": "Atualização de modelos iniciada. Pode levar alguns minutos para atualizar.",
      "REFRESH_ERROR": "Falha ao atualizar os modelos. Por favor, tente novamente.",
      "LABELS": {
        "LANGUAGE": "Idioma",
        "TEMPLATE_BODY": "Conteúdo do Template",
        "CATEGORY": "Categoria"
      }
    },
    "PARSER": {
      "VARIABLES_LABEL": "Variáveis",
      "LANGUAGE": "Idioma",
      "CATEGORY": "Categoria",
      "VARIABLE_PLACEHOLDER": "Insira o valor para {variable}",
      "GO_BACK_LABEL": "Voltar",
      "SEND_MESSAGE_LABEL": "Enviar Mensagem",
      "FORM_ERROR_MESSAGE": "Por favor, preencha todas as variáveis antes de enviar",
      "MEDIA_HEADER_LABEL": "Cabeçalho {type}",
      "OTP_CODE": "Digite OTP de 4 a 8 dígitos",
      "EXPIRY_MINUTES": "Digite os minutos de expiração",
      "BUTTON_PARAMETERS": "Parâmetros do botão",
      "BUTTON_LABEL": "Botão {index}",
      "COUPON_CODE": "Digite o código do cupom (máx. 15 caracteres)",
      "MEDIA_URL_LABEL": "Digite a URL {type}",
      "DOCUMENT_NAME_PLACEHOLDER": "Informe o nome do arquivo do documento (ex.: Comprovante_2025.pdf)",
      "BUTTON_PARAMETER": "Insira o parâmetro do botão"
    }
  }
}
